module.exports = __webpack_public_path__ + "img/four-pillars-people.77c63931.png";